import { HttpErrorResponse } from '@angular/common/http';
import { SimpleCertificate } from 'app/library/certificate/models/simple-certificate.model';
import { ModuleCertificateExtended } from 'app/library/module-certificate/models/module-certificate.extended.model';
import { ModuleCertificate } from 'app/library/module-certificate/models/module-certificate.model';
export class SetModuleCertificates {
    static readonly type = '[ModuleCertificate] SetModuleCertificates';

    constructor(public payload: ModuleCertificateExtended[]) {}
}

export class UnsetModuleCertificates {
    static readonly type = '[ModuleCertificate] UnsetModuleCertificates';
}

export class FetchModuleCertificates {
    static readonly type = '[ModuleCertificate] FetchModuleCertificates';

    constructor(
        public payload?: {
            moduleId: string;
        }
    ) {}
}

export class FetchModuleCertificatesSuccess {
    static readonly type = '[ModuleCertificate] FetchModuleCertificatesSuccess';
}

export class FetchModuleCertificatesFailure {
    static readonly type = '[ModuleCertificate] FetchModuleCertificatesFailure';
}

export class AssignCertificateTemplateToModule {
    static readonly type = '[ModuleCertificate] AssignCertificateTemplateToModule';

    constructor(
        public payload: {
            moduleId: string;
            certificateName: string;
            file: File;
            assignmentRule: number;
            sectionId?: string;
        }
    ) {}
}

export class AssignCertificateTemplateToModuleSuccess {
    static readonly type = '[ModuleCertificate] AssignCertificateTemplateToModuleSuccess';

    constructor() {}
}

export class AssignCertificateTemplateToModuleFailure {
    static readonly type = '[ModuleCertificate] AssignCertificateTemplateToModuleFailure';
}

export class AddCertificatesToModule {
    static readonly type = '[ModuleCertificate] AddCertificatesToModule';

    constructor(public payload: ModuleCertificate[]) {}
}

export class AddCertificatesToModuleSuccess {
    static readonly type = '[ModuleCertificate] AddCertificatesToModuleSuccess';

    constructor(public payload: ModuleCertificate[]) {}
}

export class AddCertificatesToModuleFailure {
    static readonly type = '[ModuleCertificate] AddCertificatesToModuleFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}

export class RemoveCertificatesFromModule {
    static readonly type = '[ModuleCertificate] RemoveCertificatesFromModule';

    constructor(public payload: ModuleCertificate) {}
}

export class RemoveCertificatesFromModuleSuccess {
    static readonly type = '[ModuleCertificate] RemoveCertificatesFromModuleSuccess';

    constructor(public payload: ModuleCertificateExtended[]) {}
}

export class RemoveCertificatesFromModuleFailure {
    static readonly type = '[ModuleCertificate] RemoveCertificatesFromModuleFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}

export class FetchParticipantModuleCertificates {
    static readonly type = '[ModuleCertificate] FetchParticipantModuleCertificates';

    constructor(public payload: string) {}
}

export class FetchParticipantModuleCertificatesSuccess {
    static readonly type = '[ModuleCertificate] FetchParticipantModuleCertificatesSuccess';

    constructor(public payload: SimpleCertificate[]) {}
}

export class FetchParticipantModuleCertificatesFailure {
    static readonly type = '[ModuleCertificate] FetchParticipantModuleCertificatesFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}
